module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.remaining < 1) ? [_vm._v("\n        Saved   \n    ")] : [_vm._v("\n        Saving in " + _vm._s(_vm.remaining) + "s...   \n        "), _c('a', {
    on: {
      "click": function($event) {
        _vm.remaining = 0
      }
    }
  }, [_vm._v("Save Now")]), _vm._v(" | \n        "), _c('a', {
    on: {
      "click": _vm.revert
    }
  }, [_vm._v("Revert")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e314736"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/Timer.vue
// module id = 2447
// module chunks = 1